import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TabSizes, TabTypes } from '@shared/models';

@Component({
  selector: 'a[ui-tab], button[ui-tab]',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  /**
   * Тип фильтра (по умолчанию, выбранный)
   */
  @Input() type: TabTypes = TabTypes.Default;
  /**
   * Размер фильтра
   */
  @Input() size: TabSizes = TabSizes.L;

  @HostBinding('class')
  get classNames(): string[] {
    return ['tab', `tab-type-${this.type}`, `tab-size-${this.size}`];
  }
}
